import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { ITaxCertificationData } from '../../ui-toolkit/taxCertifications/ITaxCertification';

export interface IPostTaxCertificationsAsyncProps {
  taxCertification: ITaxCertificationData;
  orderId: string;
}

export const postTaxCertificationsAsync = ({ taxCertification, orderId }: IPostTaxCertificationsAsyncProps) =>
  APIFactory(baseUrlService.ApiLocation)
    .post(`/lender/v1/vendor/orders/${orderId}/tax_certifications`, taxCertification)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
